import createEntityReducer from "../../common/entity/createEntityReducer";
import { actions } from "./actions";
import { entity } from "./entity";

export const reducer = createEntityReducer({
  entity,
  actions: actions,
  persist: true,
});
